import { Component } from '@angular/core';
import { RdsDialogRef } from '@rds/angular-components';
import { resourceBundleConstant } from 'src/app/utility/constant/resource-bundle-constant';

@Component({
    selector: 'app-roles-description',
    standalone: false,
    templateUrl: './roles-description.component.html',
    styleUrl: './roles-description.component.scss',
})
export class RolesDescriptionComponent {
    resourceConstant = resourceBundleConstant;

    rolesData = [
        {
            role: this.resourceConstant.roleOwner,
            description: this.resourceConstant.roleOwnerDescription,
        },
        {
            role: this.resourceConstant.roleEditor,
            description: this.resourceConstant.roleEditorDescription,
        },
        {
            role: this.resourceConstant.roleCommenter,
            description: this.resourceConstant.roleCommenterDescription,
        },
        {
            role: this.resourceConstant.roleViewer,
            description: this.resourceConstant.roleViewerDescription,
        },
    ];
    displayedColumns = ['role', 'description'];

    constructor(public dialogRef: RdsDialogRef<RolesDescriptionComponent>) {}
}
